{
  "name": "ApproveAndSwap",
  "abi": [
    {
      "inputs": [
        { "internalType": "address", "name": "_wethAddr", "type": "address" },
        { "internalType": "address", "name": "_router", "type": "address" }
      ],
      "stateMutability": "nonpayable",
      "type": "constructor"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "tokenAddr",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "SwapERC20Executed",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "SwapETHExecuted",
      "type": "event"
    },
    {
      "inputs": [],
      "name": "EMPTY_STATE",
      "outputs": [{ "internalType": "bytes", "name": "", "type": "bytes" }],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [{ "internalType": "bytes", "name": "", "type": "bytes" }],
      "name": "execute",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        { "internalType": "address", "name": "tokenAddr", "type": "address" },
        { "internalType": "uint256", "name": "amount", "type": "uint256" },
        { "internalType": "bytes", "name": "routerCallData", "type": "bytes" }
      ],
      "name": "executeSwapERC20",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        { "internalType": "uint256", "name": "amount", "type": "uint256" },
        { "internalType": "bytes", "name": "routerCallData", "type": "bytes" }
      ],
      "name": "executeSwapETH",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        { "internalType": "bytes32", "name": "key", "type": "bytes32" }
      ],
      "name": "getState",
      "outputs": [
        { "internalType": "bytes", "name": "state", "type": "bytes" }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getWeth",
      "outputs": [
        { "internalType": "contractIWETH9", "name": "", "type": "address" }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "moduleId",
      "outputs": [{ "internalType": "bytes32", "name": "", "type": "bytes32" }],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "payFee",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "router",
      "outputs": [{ "internalType": "address", "name": "", "type": "address" }],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "weth",
      "outputs": [
        { "internalType": "contractIWETH9", "name": "", "type": "address" }
      ],
      "stateMutability": "view",
      "type": "function"
    }
  ],
  "numDeployments": 1,
  "addresses": {
    "1": "0xe65d63A9B4842c0dc0916aE5368356Ca0212f2CB",
    "5": "0xe65d63A9B4842c0dc0916aE5368356Ca0212f2CB",
    "10": "0xe65d63A9B4842c0dc0916aE5368356Ca0212f2CB",
    "137": "0xe65d63A9B4842c0dc0916aE5368356Ca0212f2CB",
    "8453": "0xe65d63A9B4842c0dc0916aE5368356Ca0212f2CB",
    "36865": "0xe65d63A9B4842c0dc0916aE5368356Ca0212f2CB",
    "42161": "0xe65d63A9B4842c0dc0916aE5368356Ca0212f2CB",
    "421614": "0xd0d92c17C4123F0e8b571b0Dd0997d4a5E88Bb52"
  }
}
